<template>
    <div v-if="form_id && orderform">
        <b-modal
            v-model="showModalLocal"
            :title="'Простой диалог'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <div class="row">
                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Название формы"
                        description="Используется только в этой админке"
                    >
                        <input class="form-control" v-model="orderform.title">
                    </b-form-group>
                </div>

                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Типы объектов"
                        description="В форме будут отображатся только объекты выбранных типов. "
                    >
                        <v-select
                            v-model="orderform.htypes"
                            :options="htypes"
                            placeholder="Выберите типы"
                            :multiple="true"
                            label="title"
                        ></v-select>
                    </b-form-group>
                </div>

                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Города"
                        description="В форме будут отображатся только объекты выбранных городов."
                    >
                        <v-select
                            v-model="orderform.cities"
                            :options="cities"
                            :multiple="true"
                            placeholder="Выберите города"
                            label="title"
                        ></v-select>
                    </b-form-group>
                </div>

                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Объекты размещения"
                        description="В форме будут отображатся только выбранные объекты. Фильтры на типы и города при выбранных объектах не работают."
                    >
                        <v-select
                            v-model="orderform.hotels"
                            :options="hotels"
                            placeholder="Выберите объекты"
                            :multiple="true"
                            label="title"
                        ></v-select>
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group>
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="allow_fake_quotas" value="1" v-model="orderform.allow_fake_quotas">
                            <label class="custom-control-label" for="allow_fake_quotas">Применять фейковые квоты</label>
                        </div>
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group>
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="skip_infants_check" value="1" v-model="orderform.skip_infants_check">
                            <label class="custom-control-label" for="skip_infants_check">Игнорировать проверку "младенцы не допускаютcя"</label>
                        </div>
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group>
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="confirm_tel" value="1" v-model="orderform.confirm_tel">
                            <label class="custom-control-label" for="confirm_tel">Высылать на СМС код для подтверждения</label>
                        </div>
                    </b-form-group>
                </div>


                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Веб-сайт"
                        description="веб-сайт (без http://) на котором будет размещена форма"
                    >
                        <input class="form-control form-control-sm" v-model="orderform.website"></input>
                    </b-form-group>
                </div>

                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Сообщение отправляемое на СМС"
                        description="в месте где должен быть код подтверждения укажите %s"
                    >
                        <input class="form-control form-control-sm" v-model="orderform.tel_confirm_text"></input>
                    </b-form-group>
                </div>

                <div class="col col-12">
                    <b-form-group
                        label="Счетчики"
                        description="Код яндекс метрики и любых других счетчиков, добавляемый во фрейм с формой"
                    >
                        <textarea class="form-control form-control-sm" v-model="orderform.metrika_code"></textarea>
                    </b-form-group>
                </div>

                <div class="col col-12 col-md-6">
                    <b-form-group label="код метрики">
                        <input class="form-control form-control-sm" v-model="orderform.metrika_id"></input>
                    </b-form-group>
                </div>


                <div class="col col-12 col-md-6">
                    <b-form-group label="цель метрики">
                        <input class="form-control form-control-sm" v-model="orderform.goal_id"></input>
                    </b-form-group>
                </div>

                <div class="col col-12">
                    <b-form-group
                        label="Сообщение при успешном бронировании"
                        description="Допустим HTML. Уажите #ORDER# для подстановки номера брони."
                    >
                        <textarea class="form-control form-control-sm" v-model="orderform.success_text_booking"></textarea>
                    </b-form-group>
                </div>
                <div class="col col-12">
                    <b-form-group
                        label="Сообщение при успешном оформлении заказа"
                        description="Допустим HTML. Уажите #ORDER# для подстановки номера заказа."
                    >
                        <textarea class="form-control form-control-sm" v-model="orderform.success_text_order"></textarea>
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Возраст младенцев"
                        description="Возраст, до которого ребенок размещается бесплатно без места, (если в настройках объекта это не указано явно). Для полного отключения необходимо установить значение -1."
                    >
                        <input class="form-control" v-model="orderform.fake_infant_age">
                    </b-form-group>
                </div>
                <div class="col col-12 col-md-6">
                    <b-form-group
                        label="Cмешение для скролинга"
                        description="При переходах между экранами формы она скролируется в начало, смещение необходимо, если у сайта зафиксирована шапка в топе"
                    >
                        <input class="form-control" v-model="orderform.offset">
                    </b-form-group>
                </div>
            </div>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions.js';
    import { orderform_functions } from '@/functions/orderform.js';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_city } from '@/functions_city.js';
    import { htype_functions } from '@/functions/htype.js';

    export default {
        name: 'FormEditDialog',
        mixins: [functions, orderform_functions, functions_hotel, functions_city, htype_functions ],
        data: function () {
            return {
            };
        },
        model: {
            prop: "form_id",
            event: "hide"
        },
        props: {
            form_id: Number,
        },
        watch: {
        },

        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                this.saveOrderForm(function (self) {
                    self.$emit("change", 0);
                    self.$emit("hide", 0);
                }, this);
            },
        },

        computed: {
            showModalLocal: {
                get: function () {
                    return !!this.form_id
                },
                set: function (newValue) {}
            }
        },

        created: function() {
            this.loadOrderForm(this.form_id, function (self) {
                if (!self.orderform.success_text_booking) {
                    self.orderform.success_text_booking = "Вы успешно оформили бронь. Менеджер свяжется с вами в ближайшее время. Номер вашей брони: #ORDER#."
                }
                if (!self.orderform.success_text_order) {
                    self.orderform.success_text_order = "Вы успешно оформили заявку. Менеджер свяжется с вами в ближайшее время. Номер вашей заявки: #ORDER#."
                }
            }, this);

            this.loadHtypes();
            this.loadHotels();
            this.loadCities();
        },

    }
</script>
